import * as React from "react";
import { Box } from "@chakra-ui/react";

export default function SkipNav({}) {
  return <Box pt="7em" />;
}
